/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import { FontFamily, FontFamilyFromJSON, FontFamilyFromJSONTyped, FontFamilyToJSON } from './FontFamily'
import {
  FontFamilyNullable,
  FontFamilyNullableFromJSON,
  FontFamilyNullableFromJSONTyped,
  FontFamilyNullableToJSON
} from './FontFamilyNullable'
import {
  SiteSectionDocument,
  SiteSectionDocumentFromJSON,
  SiteSectionDocumentFromJSONTyped,
  SiteSectionDocumentToJSON
} from './SiteSectionDocument'
import { TextAlignment, TextAlignmentFromJSON, TextAlignmentFromJSONTyped, TextAlignmentToJSON } from './TextAlignment'
import {
  TextAlignmentNullable,
  TextAlignmentNullableFromJSON,
  TextAlignmentNullableFromJSONTyped,
  TextAlignmentNullableToJSON
} from './TextAlignmentNullable'

/**
 *
 * @export
 * @interface SiteSection
 */
export interface SiteSection {
  /**
   *
   * @type {string}
   * @memberof SiteSection
   */
  id?: string
  /**
   *
   * @type {string}
   * @memberof SiteSection
   */
  name?: string
  /**
   *
   * @type {number}
   * @memberof SiteSection
   */
  sort?: number
  /**
   *
   * @type {TextAlignmentNullable}
   * @memberof SiteSection
   */
  titleAlignment?: TextAlignmentNullable | null
  /**
   *
   * @type {FontFamilyNullable}
   * @memberof SiteSection
   */
  titleFontFamily?: FontFamilyNullable | null
  /**
   * タイトル文字サイズ (10-72)
   * @type {number}
   * @memberof SiteSection
   */
  titleFontSize?: number | null
  /**
   * 16進数カラーコード (#XXXXXX形式または#XXX短縮形式、null許容)
   * @type {string}
   * @memberof SiteSection
   */
  titleTextColor?: string | null
  /**
   *
   * @type {TextAlignment}
   * @memberof SiteSection
   */
  displayTitleAlignment?: TextAlignment
  /**
   *
   * @type {FontFamily}
   * @memberof SiteSection
   */
  displayTitleFontFamily?: FontFamily
  /**
   * タイトル文字サイズ (デフォルト適用後、10-72)
   * @type {number}
   * @memberof SiteSection
   */
  displayTitleFontSize?: number
  /**
   * 16進数カラーコード (#XXXXXX形式または#XXX短縮形式)
   * @type {string}
   * @memberof SiteSection
   */
  displayTitleTextColor?: string
  /**
   *
   * @type {string}
   * @memberof SiteSection
   */
  createdAt?: string
  /**
   *
   * @type {string}
   * @memberof SiteSection
   */
  updatedAt?: string
  /**
   *
   * @type {Array<SiteSectionDocument>}
   * @memberof SiteSection
   */
  siteSectionDocuments?: Array<SiteSectionDocument>
}

export function SiteSectionFromJSON(json: any): SiteSection {
  return SiteSectionFromJSONTyped(json, false)
}

export function SiteSectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): SiteSection {
  if (json === undefined || json === null) {
    return json
  }
  return {
    id: !exists(json, 'id') ? undefined : json['id'],
    name: !exists(json, 'name') ? undefined : json['name'],
    sort: !exists(json, 'sort') ? undefined : json['sort'],
    titleAlignment: !exists(json, 'title_alignment')
      ? undefined
      : TextAlignmentNullableFromJSON(json['title_alignment']),
    titleFontFamily: !exists(json, 'title_font_family')
      ? undefined
      : FontFamilyNullableFromJSON(json['title_font_family']),
    titleFontSize: !exists(json, 'title_font_size') ? undefined : json['title_font_size'],
    titleTextColor: !exists(json, 'title_text_color') ? undefined : json['title_text_color'],
    displayTitleAlignment: !exists(json, 'display_title_alignment')
      ? undefined
      : TextAlignmentFromJSON(json['display_title_alignment']),
    displayTitleFontFamily: !exists(json, 'display_title_font_family')
      ? undefined
      : FontFamilyFromJSON(json['display_title_font_family']),
    displayTitleFontSize: !exists(json, 'display_title_font_size') ? undefined : json['display_title_font_size'],
    displayTitleTextColor: !exists(json, 'display_title_text_color') ? undefined : json['display_title_text_color'],
    createdAt: !exists(json, 'created_at') ? undefined : json['created_at'],
    updatedAt: !exists(json, 'updated_at') ? undefined : json['updated_at'],
    siteSectionDocuments: !exists(json, 'site_section_documents')
      ? undefined
      : (json['site_section_documents'] as Array<any>).map(SiteSectionDocumentFromJSON)
  }
}

export function SiteSectionToJSON(value?: SiteSection | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    id: value.id,
    name: value.name,
    sort: value.sort,
    title_alignment: TextAlignmentNullableToJSON(value.titleAlignment),
    title_font_family: FontFamilyNullableToJSON(value.titleFontFamily),
    title_font_size: value.titleFontSize,
    title_text_color: value.titleTextColor,
    display_title_alignment: TextAlignmentToJSON(value.displayTitleAlignment),
    display_title_font_family: FontFamilyToJSON(value.displayTitleFontFamily),
    display_title_font_size: value.displayTitleFontSize,
    display_title_text_color: value.displayTitleTextColor,
    created_at: value.createdAt,
    updated_at: value.updatedAt,
    site_section_documents:
      value.siteSectionDocuments === undefined
        ? undefined
        : (value.siteSectionDocuments as Array<any>).map(SiteSectionDocumentToJSON)
  }
}
